export function OptinCTSTitleViewConstructor(services, callbacks, context, siteTypeConfig) {
  const joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    editElementModalController: 'chooseOptinCTSTitleController',
    editElementModalTemplate: require('./chooseOptinCTSTitle.modal.html'),

    angularTemplate: require('./OptinCTSTitleView.html'),

    init: function () {},
  });
}
